import Masonry from "masonry-layout";

import selectric from "selectric";

const News = {
  init() {
    News.resizeImages();
    News.masonry();
    News.filters();
  },

  filters() {
    $(".news-filter__select")
      .selectric()
      .on("change", function () {
        window.location = $(this).val();
      });
  },

  masonry() {
    const masonry = new Masonry(".news-masonry", {
      columnWidth: ".news-sizer",
      itemSelector: ".news-item",
      percentPosition: true,
      gutter: 38,
      horizontalOrder: true,
      transitionDuration: "0.2s",
    });
  },

  resizeImages() {
    $(".news-item__img").each((idx, img) => {
      const padding = News.calculatePadding($(img).attr("data-aspect"));

      $(img).css({ paddingBottom: `${padding}%` });
    });
  },

  calculatePadding(aspectRatio) {
    const tmp = aspectRatio.split(":");
    const width = parseInt(tmp[0]);
    const height = parseInt(tmp[1]);

    return (100 * height) / width;
  },
};

export default News;

/**
 * 16 == 100
 * 9 == x
 *
 * x = 100*9/16
 */
